import { Injectable } from '@angular/core';
import { BaseErrorHandlerModel, ExtendedServerErrorResponse, LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class DefaultErrorHandlerService extends BaseErrorHandlerModel {
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('DefaultErrorHandlerService::handle:', error);
        let errorMessage = error.error.message ?? `Error Code: ${error.status}\nMessage: ${error.message}`;
        let alertHeading = 'An error has occurred';

        if ('context' in error.error && error.error.context) {
            alertHeading = error.error.context as string;
        }
        // If the errors object has contents, append them to the error message
        if (error.error.errors && Object.keys(error.error.errors).length > 0) {
            errorMessage = Object.entries(error.error.errors)
                .map(([key, value]) => `${value}`)
                .join('<br />');
        }
        this.alertService.error(errorMessage, { heading: alertHeading, keepAfterRouteChange: false });
    }
}
